import React, { Component } from 'react'
import { Form, SelectInput } from '../UI'
import { compose, graphql } from 'react-apollo'
import { ALL_LANGUAGES, CATEGORIES, EXPERTISES } from '../../constants'
import SliderActivities from './SliderActivities'
import GET_TOP_10_GURUS from '../../graphql/HomePage/GetTop10Guru.graphql'
import { observer } from 'mobx-react'
import searchStore from '../../mobx-store/search-store'
import R from 'ramda'
import moment from 'moment'

class TripGuru extends Component {
  constructor() {
    super()
    this.state = {
      filterActive: false,
      selectedCategorie: 'Any',
      selectedLanguage: 'All',
      selectedExpertises: 'Any',
      filtered: false
    }
  }

  getAllLanguages = () => [
    { value: 'All', label: 'All' },
    ...ALL_LANGUAGES.map(item => ({
      value: item['1'],
      label: item.name
    }))
  ]

  getCategoriesOptions = () => {
    const options = []
    options.push({ label: 'Any', value: 'Any' })
    for (let key in CATEGORIES) {
      options.push({ label: key, value: key })
    }
    return options
  }

  getExperticeOptions = () => {
    const options = []
    options.push({ label: 'Any', value: 'Any' })
    for (let key in EXPERTISES) {
      options.push({ label: EXPERTISES[key], value: key })
    }
    return options
  }

  handleSubmit = values => {
    //arr1.reduce((acc, r)=> arr2.includes(r)?acc:false, true)
    this.setState({
      selectedCategorie: values.categories,
      selectedLanguage: values.languages,
      selectedExpertises: values.expertise,
      filterActive: false,
      filtered: true
    })
  }

  render() {
    const { tripGurus, featuredDestinations } = this.props
    return (
      <div className="main-container">
        <div className="filter-section">
          {/*extract later in separate filter component*/}
          <div className="filter-component">
            <button
              className={this.state.filterActive ? 'active filter-btn' : 'filter-btn'}
              onClick={() => this.setState({ filterActive: !this.state.filterActive })}
            >
              Filter
            </button>
            {this.state.filterActive && (
              <Form
                onSubmit={this.handleSubmit}
                submitBtnClassname="btn btn-lg btn-primary btn-danger"
                submitBtnName={'Apply'}
                className="filter-content"
              >
                <SelectInput
                  id="categories"
                  initialValue={'Any'}
                  options={this.getCategoriesOptions()}
                  label={'Categories'}
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
                <SelectInput
                  id="expertise"
                  initialValue={'Any'}
                  options={this.getExperticeOptions()}
                  label={'Special expertise'}
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
                <SelectInput
                  id="languages"
                  initialValue={'All'}
                  options={this.getAllLanguages()}
                  label={'Languages'}
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
              </Form>
            )}
          </div>
        </div>

        {!searchStore.pickedPlace.country &&
          !searchStore.rangeDate.endDate &&
          !this.state.filtered && (
            <SliderActivities
              collection={featuredDestinations.contentpoi.slice(0, 10)}
              type={'destination'}
              title={'Featured Destination'}
            />
          )}
        {/*<SliderActivities collection={recentlyBooked.allPaymentTransactions.slice(0, 10)} type={'booked'}
                          title={'Just Booked'}/>*/}
        <SliderActivities
          collection={tripGurus.user
            .filter(
              guru =>
                guru.plannerProfile && guru.plannerProfile.languages && guru.plannerProfile.categories && guru.plannerProfile.expertises
            )
            .filter(
              item =>
                (item.plannerProfile.languages.includes(this.state.selectedLanguage) || this.state.selectedLanguage === 'All') &&
                (item.plannerProfile.categories.includes(this.state.selectedCategorie) || this.state.selectedCategorie === 'Any') &&
                (item.plannerProfile.expertises.includes(this.state.selectedExpertises) || this.state.selectedExpertises === 'Any')
            )
            .filter(
              item =>
                R.contains(searchStore.pickedPlace.country, item.plannerProfile.locations.map(item => item.country)) ||
                !searchStore.pickedPlace.country
            )
            .filter(
              item =>
                !searchStore.rangeDate.startDate ||
                !searchStore.rangeDate.endDate ||
                item.customizedPlans.reduce(
                  (acc, item) =>
                    moment(item.startDate).diff(searchStore.rangeDate.startDate) >= 0 &&
                    moment(item.endDate).diff(searchStore.rangeDate.endDate) <= 0
                      ? true
                      : acc,
                  false
                )
            )
            .slice(0, 10)}
          type={'plan'}
          country={searchStore.pickedPlace.country}
          title={'Travel Gurus'}
        />
      </div>
    )
  }
}

export default compose(
  // graphql(GET_GURUS_BY_LOCATION, {
  //   name: 'getGuruByLocation',
  //   options: props => ({
  //     variables: {
  //       country: props.guruLocation || ''
  //     }
  //   })
  // }),
  graphql(GET_TOP_10_GURUS, {
    name: 'getTopGuru'
  })
)(observer(TripGuru))



// WEBPACK FOOTER //
// src/components/homepage/TripGuruComponent.js